document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("pincode-input");
  const button = document.getElementById("check-estimate-btn");
  const result = document.getElementById("delivery-estimate-result");

  const zones = window.deliveryZones || [];
  const defaultEstimate = window.defaultEstimate || { from: 5, to: 8 };

  function isIndianPincode(pin) {
    const p = parseInt(pin);
    return /^\d{6}$/.test(pin) && p >= 100000 && p <= 999999;
  }

  function getDateFromToday(offset) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return date.toLocaleDateString("en-IN", {
      weekday: "long", // 🗓️ Adds day name
      day: "numeric",
      month: "long",
    });
  }

  button.addEventListener("click", () => {
    const pincode = input.value.trim();

    if (!isIndianPincode(pincode)) {
      result.textContent = "❌ Please enter a valid 6-digit Indian pincode.";
      return;
    }

    const pin = parseInt(pincode, 10);
    let matched = false;

    for (const zone of zones) {
      const start = parseInt(zone.from);
      const end = parseInt(zone.to);
      const daysFrom = parseInt(zone.daysFrom);
      const daysTo = parseInt(zone.daysTo);

      if (!isNaN(start) && !isNaN(end) && pin >= start && pin <= end) {
        const fromDate = getDateFromToday(daysFrom);
        const toDate = getDateFromToday(daysTo);
        result.textContent = `📦  ${fromDate} - ${toDate}.`;
        matched = true;
        break;
      }
    }

    if (!matched) {
      const fromDate = getDateFromToday(parseInt(defaultEstimate.from));
      const toDate = getDateFromToday(parseInt(defaultEstimate.to));
      result.textContent = `📦  ${fromDate} - ${toDate}.`;
    }
  });
});
